import type { FC } from "react";
import { formatImpressionAxis } from "@/pages/CampaignOverviewPage/charts/chartHelpers";
import type { FunnelStageShape } from "@/pages/CampaignOverviewPage/utils/videoFunnelStages";
import styles from "@/pages/CampaignOverviewPage/components/VideoFunnel.module.css";

// Shapes are drawn in a 100 × 52 box stretched to the row, so widths read as
// percentages and the 52px stage height comes from the row, not the viewBox.
const VIEW_WIDTH = 100;
const VIEW_HEIGHT = 52;
const PERCENT_DECIMALS = 1;

const toPolygonPoints = ({ bottomWidth, topWidth }: FunnelStageShape) => {
  const topInset = ((1 - topWidth) * VIEW_WIDTH) / 2;
  const bottomInset = ((1 - bottomWidth) * VIEW_WIDTH) / 2;
  return [
    [topInset, 0],
    [VIEW_WIDTH - topInset, 0],
    [VIEW_WIDTH - bottomInset, VIEW_HEIGHT],
    [bottomInset, VIEW_HEIGHT],
  ]
    .map((point) => point.join(","))
    .join(" ");
};

interface VideoFunnelProps {
  shapes: FunnelStageShape[];
}

const VideoFunnel: FC<VideoFunnelProps> = ({ shapes }) => (
  <ol className={styles.funnel}>
    {shapes.map((shape, index) => (
      <li key={shape.label} className={styles.stage}>
        <span className={styles.name}>{shape.label}</span>
        <svg
          aria-hidden="true"
          className={styles.shape}
          preserveAspectRatio="none"
          viewBox={`0 0 ${VIEW_WIDTH} ${VIEW_HEIGHT}`}
        >
          <polygon
            points={toPolygonPoints(shape)}
            style={{ fill: `var(--funnel-${index + 1})` }}
          />
        </svg>
        <span className={styles.metrics}>
          <span className={styles.count}>
            {formatImpressionAxis(shape.value)}
          </span>
          <span className={styles.percent}>
            {shape.percentOfStart.toFixed(PERCENT_DECIMALS)}%
          </span>
        </span>
      </li>
    ))}
  </ol>
);

export default VideoFunnel;
